import axios from 'axios';

const bhcalc = axios.create({
  baseURL: process.env.REACT_APP_BHCALC_API_URL,
  timeout: 10000,
});

// Add auth token to all requests
bhcalc.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default bhcalc;
